import { render } from "./ComponentDemolitionView.vue?vue&type=template&id=6b86e9a6&scoped=true"
import script from "./ComponentDemolitionView.vue?vue&type=script&lang=js"
export * from "./ComponentDemolitionView.vue?vue&type=script&lang=js"

import "./ComponentDemolitionView.vue?vue&type=style&index=0&id=6b86e9a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b86e9a6"]])

export default __exports__